module.exports = __webpack_public_path__ + "static/media/cq_elimina.ba8b102b.svg";